var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 168,
    viewBox: "0 0 165 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.929 83.7035C126.929 108.192 107.046 128.074 82.5581 128.074C58.0697 128.074 38.1875 108.192 38.1875 83.7035C38.1875 59.2151 58.0697 39.3329 82.5581 39.3329C107.046 39.3329 126.929 59.2151 126.929 83.7035Z",
    fill: "#FFC557"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2109 30.8192L82.5574 0.0338135L89.8456 30.8192H75.2109Z",
    fill: "#FFC557"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5446 36.5329L53.9297 5.1062L71.3048 31.5187L57.5446 36.5329Z",
    fill: "#FFC557"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9105 47.9006L28.7422 19.6223L54.1051 38.5133L42.9105 47.9006Z",
    fill: "#FFC557"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0584 63.5887L10.0859 41.899L40.4049 50.9364L33.0584 63.5887Z",
    fill: "#FFC557"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1495 81.72L0.113281 69.1843L31.7149 67.3185L29.1495 81.72Z",
    fill: "#FFC557"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7149 100.086L0.113281 98.2784L29.1495 85.7427L31.7149 100.086Z",
    fill: "#FFC557"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3466 116.529L10.0859 125.566L33.0584 103.876L40.3466 116.529Z",
    fill: "#FFC557"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1051 128.946L28.7422 147.837L42.9105 119.559L54.1051 128.946Z",
    fill: "#FFC557"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3048 135.945L53.9297 162.357L57.5446 130.93L71.3048 135.945Z",
    fill: "#FFC557"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8456 136.646L82.5574 167.431L75.2109 136.646H89.8456Z",
    fill: "#FFC557"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.514 130.93L111.187 162.357L93.7539 135.945L107.514 130.93Z",
    fill: "#FFC557"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.152 119.559L136.32 147.837L110.957 128.946L122.152 119.559Z",
    fill: "#FFC557"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.999 103.876L155.03 125.566L124.711 116.529L131.999 103.876Z",
    fill: "#FFC557"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.909 85.7427L164.946 98.2784L133.402 100.144L135.909 85.7427Z",
    fill: "#FFC557"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.402 67.3185L164.946 69.1843L135.909 81.72L133.402 67.3185Z",
    fill: "#FFC557"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.711 50.9364L155.03 41.899L131.999 63.5887L124.711 50.9364Z",
    fill: "#FFC557"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.957 38.5133L136.32 19.6223L122.152 47.9006L110.957 38.5133Z",
    fill: "#FFC557"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7539 31.517L111.187 5.04626L107.514 36.5313L93.7539 31.517Z",
    fill: "#FFC557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesSun);
export default __webpack_public_path__ + "static/media/StoriesSun.09e2d0fe63ede114b87ab0404c94d29b.svg";
export { ForwardRef as ReactComponent };